// frontend/src/pages/MyProductsPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { formatCurrency } from '../services/utils'; // Asegúrate de importar esto

function MyProductsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = async () => {
    try {
      const response = await api.get('/users/me/items');
      setItems(response.data);
    } catch (error) {
      console.error("Error al cargar mis productos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleDelete = async (itemId) => {
    if (window.confirm('¿Estás seguro de que quieres eliminar este producto?')) {
      try {
        await api.delete(`/items/${itemId}`);
        fetchItems();
      } catch (error) {
        alert('No se pudo eliminar el producto.');
      }
    }
  };

  if (loading) return <p>Cargando tus productos...</p>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Mis Publicaciones</h2>
        <Link to="/publicar" className="btn btn-primary">Publicar Nuevo</Link>
      </div>
      {items.length === 0 ? (
        <p>Aún no has publicado ningún producto.</p>
      ) : (
        <div className="card shadow-sm">
            <table className="table table-hover mb-0">
            <thead className="table-light">
                <tr>
                <th scope="col">Título</th>
                <th scope="col">Precio</th>
                <th scope="col">Estado</th>
                <th scope="col">Acciones</th>
                </tr>
            </thead>
            <tbody>
                {items.map(item => (
                <tr key={item.id}>
                    <td>{item.titulo}</td>
                    <td>{formatCurrency(item.precio)}</td>
                    {/* CORRECCIÓN AQUÍ: Faltaba el '<' de apertura */}
                    <td>{item.estado}</td>
                    <td>
                    <Link to={`/items/${item.id}`} className="btn btn-sm btn-info me-2">Ver</Link>
                    <Link to={`/items/${item.id}/editar`} className="btn btn-sm btn-warning me-2">Editar</Link>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Eliminar</button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
      )}
    </div>
  );
}

export default MyProductsPage;
